import ClearDeployment from './ClearDeployment.container'

export default ClearDeployment
